import http from "../../http";

const order = {
    printOrder(r) {
        return http.confirm.post("/gateway/apps/o2o/api/o2o/order/printOrder", r)
    },
    getSupplierCategoryByList(r) {
        return http.get("/gateway/apps/o2o/api/o2o/admin/getSupplierCategoryByList", r)
    },
    agreeRefundOrder(r) {
        return http.confirm.post("/gateway/apps/o2o/api/o2o/admin/agreeRefundOrder", r)
    },
    rejectBackOrder(r) {
        return http.post("/gateway/apps/o2o/api/o2o/admin/rejectBackOrder", r)
    },
    refund(r) {
        return http.confirm.post("/gateway/apps/o2o/api/o2o/admin/refund", r)
    },
    listCompanyGoods(r) {
        return http.get("/gateway/apps/o2o/api/o2o/goods/listCompanyGoods", r)
    },
    listSupplierAll(r) {
        return http.get("/gateway/apps/o2o/api/o2o/admin/listSupplierAll", r)
    },
    getGoodsBySupplierId(r) {
        return http.get("/gateway/apps/o2o/api/o2o/goods/getGoodsBySupplierId", r)
    },
    terminalGroupList(r) {
        return http.get("/gateway/apps/o2o/api/terminal/terminalGroupList", r)
    },
    getOperatorBindGroupList(r) {
        return http.get("/gateway/apps/o2o/api/terminal/getOperatorBindGroupList", r)
    },
    selectOperatorGoodsPage(r) {
        return http.get("/gateway/apps/o2o/api/o2o/v3/goods/selectOperatorGoodsPage", r)
    },
    selectOperatorGoodsNoSpPage(r) {
        return http.get("/gateway/apps/o2o/api/o2o/v3/goods/selectOperatorGoodsNoSpPage", r)
    },
    updateGoodsCommission(r) {
        return http.confirm.payload("/gateway/apps/o2o/api/o2o/v3/goods/updateGoodsCommission", r)
    },
    updateTerminalGoodsDisplay(r) {
        return http.confirm.payload("/gateway/apps/o2o/api/terminal/goods/updateTerminalGoodsDisplay", r)
    },
    listOperatorHasSupplier(r) {
        return http.get("/gateway/apps/o2o/api/o2o/admin/listOperatorHasSupplier", r)
    },
    listLikeGoods(r) {
        return http.get("/gateway/apps/o2o/api/o2o/goods/listLikeGoods", r)
    },
    
}
export default order
